(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-profile', {
            parent: 'entity',
            url: '/public-profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.publicProfile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-profile/public-profiles.html',
                    controller: 'PublicProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-profile-detail', {
            parent: 'entity',
            url: '/public-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.publicProfile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-profile/public-profile-detail.html',
                    controller: 'PublicProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicProfile', function($stateParams, PublicProfile) {
                    return PublicProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-profile-detail.edit', {
            parent: 'public-profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-dialog.html',
                    controller: 'PublicProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicProfile', function(PublicProfile) {
                            return PublicProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-profile.new', {
            parent: 'public-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-dialog.html',
                    controller: 'PublicProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                version: null,
                                login: null,
                                title: null,
                                screenName: null,
                                screenNameStatus: null,
                                description: null,
                                descriptionStatus: null,
                                genderEnum: null,
                                age: null,
                                avatar: null,
                                avatarContentType: null,
                                originalUri: null,
                                largeUri: null,
                                mediumUri: null,
                                smallUri: null,
                                thumbnailUri: null,
                                photoCount: null,
                                videoCount: null,
                                online: false,
                                lastOnline: null,
                                status: null,
                                emailValidated: null,
                                confirmed: null,
                                paid: false,
                                premium: false,
                                interests: null,
                                tags: null,
                                preferredLanguage: null,
                                spokenLanguages: null,
                                rating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-profile', null, { reload: 'public-profile' });
                }, function() {
                    $state.go('public-profile');
                });
            }]
        })
        .state('public-profile.edit', {
            parent: 'public-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-dialog.html',
                    controller: 'PublicProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicProfile', function(PublicProfile) {
                            return PublicProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-profile', null, { reload: 'public-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-profile.delete', {
            parent: 'public-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-profile/public-profile-delete-dialog.html',
                    controller: 'PublicProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicProfile', function(PublicProfile) {
                            return PublicProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-profile', null, { reload: 'public-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
